import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChild,
    TemplateRef,
    ChangeDetectorRef,
    ViewContainerRef,
    NgModuleRef,
    Injector,
    Compiler,
    ElementRef
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclList,
    CclListColumn,
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates,
    CclListColumnSize,
    CclMessageService,
    CclNavbarFooterService,
    CclRouteTab,
    CclDrawerService,
    CclNotifyService,
    CclPopupService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { ListService } from "../../../list-service";
import { cloneDeep } from "lodash";
import { isEqual } from "lodash";
import { SessionService } from "../../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import * as mustache from "mustache";
import { FlashMessagesService } from "angular2-flash-messages";
import { AttendeeSessionService } from "../../../../../modules/shared/services/attendee-session.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { DatePipe } from "@angular/common";
import { SessionSectionView } from "../../../../../views/attendee-feature";
import { CookieService } from "ngx-cookie";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import * as moment from 'moment';
import 'moment-timezone';

@Component({
    selector: "app-general-page",
    templateUrl: "./general-page.view.html",
    styleUrls: []
})
export class GeneralPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    topLevelIndex;
    mustache = mustache;
    secondLevelIndex;
    thirdLevelIndex;
    sessionConfigObj: any;
    sessionDataConfig: any = {};
    remainingLevel: any;
    sessionDefaultGroupConfig: any = {};
    previewOnAdmin: any;

    @ViewChild("generalList", { read: ViewContainerRef })
    generalList: ViewContainerRef;

    sessionFilterSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "item_text",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true
    };

    tracksDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "trackName",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    typesDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "sessionType",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    attendeeTypesDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    tagDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    sessionStatus: any = [
        { id: "0", item_text: "Published", disabled: true },
        { id: 6, item_text: "Scheduled" },
        { id: 4, item_text: "Qualified" }
    ];

    selectedSessionStatus = [];
    selectedSessionType = [];
    selectedSessionTrack = [];
    selectedAttendeeType = [];
    hideFullSessions: boolean = false;

    today: any = new Date();
    firstLevelSort = [];
    secondLevelSort = [];
    thirdLevelSort = [];
    sortOn = [
        {
            label: "Start Date",
            code: "date"
        },
        {
            label: "Start Date / Start Time",
            code: "dateTime"
        },
        {   
            label: "Track",
            code: "track"
        },
        {
            label: "Type",
            code: "type"
        }
    ];

    groupTemplate: any = {
        group: [
            {
                label: " Grouping Style 1: Start Date -> Track -> Type",
                code: "group1",
                topLevel: {
                    sortingBy: "date",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                secondLevel: {
                    sortingBy: "track",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                thirdLevel: {
                    sortingBy: "type",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                dateTimeFormats: {
                    dateFormat: "EEEE, MMMM dd",
                    timeFormat: "hh:mm a"
                }
            },
            {
                label: " Grouping Style 2: Type -> Track",
                code: "group2",
                topLevel: {
                    sortingBy: "type",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                secondLevel: {
                    sortingBy: "track",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                thirdLevel: {
                    sortingBy: null,
                    active: false,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                dateTimeFormats: {
                    dateFormat: "EEEE, MMMM dd",
                    timeFormat: "hh:mm a"
                }
            },
            {
                label: " Grouping Style 3: Track -> Type",
                code: "group3",
                topLevel: {
                    sortingBy: "track",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                secondLevel: {
                    sortingBy: "type",
                    active: true,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                thirdLevel: {
                    sortingBy: null,
                    active: false,
                    textConfig: { backgroundColor: "", fontStyle: "", fontSize: "", fontColor: "" }
                },
                dateTimeFormats: {
                    dateFormat: "EEEE, MMMM dd",
                    timeFormat: "hh:mm a"
                }
            }
        ]
    };

    defaultData: boolean = false;

    defaultSessionData: any = {
        completeCollectionSize: 0,
        size: 2,
        maxResults: 2,
        startingIndex: 0,
        sessions: [
            {
                id: 28127,
                sessionId: 10743,
                sessionTitle: "Analytics (Devices, Sherlock & SCIO)",
                sessionCode: "AnalyticsSCIO",
                instanceCode: "Analytics_28127",
                occurrenceCode: "Analytics_28127",
                publishAttendeeTypes: "all",
                publishedAttendeeTypeDetails: [
                    {
                        id: 5893,
                        name: "Attendee",
                        code: "Attendee"
                    }
                ],
                locationName: "Santa clara",
                locationCode: "san",
                trackName: "track-1",
                trackColour: null,
                notes: null,
                startTime: "2017-01-17 08:00:00",
                endTime: "2017-01-17 08:10:00",
                stime: "08:00:00",
                etime: "08:10:00",
                session_dateCreated: "2019-01-22 12:16:32",
                session_dateModified: "2019-01-24 15:23:08",
                occurrence_dateCreated: null,
                occurrence_dateModified: null,
                instance_dateCreated: "2019-01-22 12:16:32",
                instance_dateModified: "2019-01-24 15:31:04",
                isActive: true,
                feeBased: false,
                capacity: 6,
                overrideCapacity: false,
                waitlistedLimit: 2,
                eventId: 3406,
                eventCode: "bulk500",
                pkEventId: "0x649810001",
                abstractDesc: "",
                sessionDescription: "",
                typeName: "Keynotes",
                points: null,
                ceuCredits: null,
                level: null,
                documents: [],
                sessionLabel: null,
                tags: [],
                speakers: [],
                customFields: [],
                confIndustry: null,
                confJobFunction: null,
                submitter: {
                    id: null,
                    eventId: null,
                    firstName: null,
                    lastName: null,
                    organization: null,
                    position: null,
                    email: null,
                    eventCode: "bulk500",
                    active: false
                },
                trackId: 101,
                levelId: null,
                locationId: 1609,
                customFieldMap: null
            },
            {
                id: 28137,
                sessionId: 10753,
                sessionTitle: "Arquitecturas de Alto Desempeno con EtherNet/IP",
                sessionCode: "ArquitecturasDesempeno",
                instanceCode: "Arquitecturas_28137",
                occurrenceCode: "Arquitecturas_28137",
                publishAttendeeTypes: "all",
                publishedAttendeeTypeDetails: [
                    {
                        id: 5893,
                        name: "Attendee",
                        code: "Attendee"
                    }
                ],
                locationName: "Washington",
                locationCode: "Washington",
                trackName: "track-2",
                trackColour: null,
                notes: null,
                startTime: "2017-01-18 08:10:00",
                endTime: "2017-01-18 08:20:00",
                stime: "08:10:00",
                etime: "08:20:00",
                session_dateCreated: "2019-01-22 12:16:32",
                session_dateModified: "2019-01-22 16:25:32",
                occurrence_dateCreated: null,
                occurrence_dateModified: null,
                instance_dateCreated: "2019-01-22 12:16:32",
                instance_dateModified: "2019-01-24 15:32:56",
                isActive: true,
                feeBased: false,
                capacity: 6,
                overrideCapacity: false,
                waitlistedLimit: 2,
                eventId: 3406,
                eventCode: "bulk500",
                pkEventId: "0x649810001",
                abstractDesc: "",
                sessionDescription: "",
                typeName: "Keynotes",
                points: null,
                ceuCredits: null,
                level: null,
                documents: [],
                sessionLabel: null,
                tags: [],
                speakers: [],
                customFields: [],
                confIndustry: null,
                confJobFunction: null,
                submitter: {
                    id: null,
                    eventId: null,
                    firstName: null,
                    lastName: null,
                    organization: null,
                    position: null,
                    email: null,
                    eventCode: "bulk500",
                    active: false
                },
                trackId: 102,
                levelId: null,
                locationId: 1621,
                customFieldMap: null
            }
        ]
    };
    defaultTimeZoneKey: any;
    sortCase;
    sessionPreviewData: any = {};
    generalSessionConfig;
    sessions: CclList = <CclList>{ pagination: {} };
    filterConfig;
    primarySortList = [
        {
            label: "Title",
            code: "title"
        },
        {   
            label: "Track",
            code: "track"
        },
        {
            label: "Type",
            code: "type"
        }
    ];
    sortOrder = [
        {

            label: 'Ascending',
            code: 'asc'
        },
        {
            label: 'Descending',
            code: 'desc'
        }
    ];

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private catalogService: CatalogService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService,
        private router: Router,
        private attendeeSessionService: AttendeeSessionService,
        private compiler: Compiler,
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private datePipe: DatePipe,
        public ngxSmartModalService: NgxSmartModalService,
        private notifyService: CclNotifyService,
        private cookieService: CookieService,
        private popupService: CclPopupService,
        private route: ActivatedRoute,
        private sessionService: SessionService,
        private elementRef: ElementRef
    ) {
        super(sharedService);
        this.previewOnAdmin = new SessionSectionView(
            navSecondaryService,
            sharedService,
            router,
            attendeeSessionService,
            catalogService,
            compiler,
            injector,
            moduleRef,
            datePipe,
            ngxSmartModalService,
            messageService,
            notifyService,
            cookieService,
            _flashMessagesService,
            popupService,
            route,
            sessionService,
            elementRef
        );
        this.defaultTimeZoneKey = this.sharedService.timezonekey
        moment.tz.setDefault(this.defaultTimeZoneKey);
        this.navSecondaryService.sectionLabel = "Data";
        this.remainingLevel = 2;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSessionConfig(message));
        this.sharedService.renderViewSubject.subscribe((value) => {
            if (value) {
                this.renderView();
                this.sharedService.generalPreviewRefRender = false;
            }
        });

        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.DATA["general"]];
        this.filterConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
        );
        if(!('selectTimezone' in this.filterConfig)) {
            this.filterConfig.selectTimezone = 'browser_timezone';
        }

        if (this.sharedService.event.eventDelivery === 'In Person' && this.filterConfig.isDefaultTimezone == true) {
            this.filterConfig.selectTimezone = 'event_timezone';
        }
        this.sharedService.sessionEnumCustomFields.forEach((element) => {
            if(element.questionTypeId == 4 || element.questionTypeId == 6) {
                this.sortOn.push({
                    'label': element.name,
                    'code': element.code
                })
            }
        });

        this.firstLevelSort = cloneDeep(this.sortOn);

        this.sharedService.sessionCustomFields.forEach(element => {
            if(element.questionTypeId == 1 || element.questionTypeId == 4 || element.questionTypeId == 6) {
                this.primarySortList.push({
                    'label': element.name,
                    'code': element.code
                })
            }
        });
        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionDataConfig = cloneDeep(this.sharedService.dataConfig["general"]);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.DATA["general"]
            };
        } else {
            this.sessionDataConfig = JSON.parse(this.sessionConfigObj.config);
            this.sortOn.forEach(element => {
                if((this.sessionDataConfig.topLevel.sortingBy == 'date' && element.code == 'dateTime') || (this.sessionDataConfig.topLevel.sortingBy == 'dateTime' && element.code == 'date')) {
                    
                } else if(element.code != this.sessionDataConfig.topLevel.sortingBy) {
                    this.secondLevelSort.push(element);
                }
            });
    
            this.secondLevelSort.forEach(element => {
                if((this.sessionDataConfig.secondLevel.sortingBy == 'date' && element.code == 'dateTime') || (this.sessionDataConfig.secondLevel.sortingBy == 'dateTime' && element.code == 'date')) {
                    
                } else if(element.code != this.sessionDataConfig.topLevel.sortingBy && element.code != this.sessionDataConfig.secondLevel.sortingBy) {
                    this.thirdLevelSort.push(element);
                }
            });
            if (this.sessionDataConfig.hasOwnProperty("defaultFilters")) {
                if (this.sessionDataConfig.defaultFilters.status.length > 0) {
                    this.selectedSessionStatus = cloneDeep(this.sessionDataConfig.defaultFilters.status);
                }

                if (this.sessionDataConfig.defaultFilters.track.length > 0) {
                    this.selectedSessionTrack = cloneDeep(this.sessionDataConfig.defaultFilters.track);
                }

                if (this.sessionDataConfig.defaultFilters.type.length > 0) {
                    this.selectedSessionType = cloneDeep(this.sessionDataConfig.defaultFilters.type);
                }

                if (this.sessionDataConfig.defaultFilters.attendeeType.length > 0) {
                    this.selectedAttendeeType = cloneDeep(this.sessionDataConfig.defaultFilters.attendeeType);
                }
                if (this.sessionDataConfig.defaultFilters.hideFullSessions) {
                    this.hideFullSessions = cloneDeep(this.sessionDataConfig.defaultFilters.hideFullSessions);
                }
            }

            if(!this.sessionDataConfig.defaultFilters.hasOwnProperty('tags')) {
                this.sessionDataConfig.defaultFilters.tags = []; 
            }


            if(!('showHidePastFilter' in this.sessionDataConfig)) {
                this.sessionDataConfig.showHidePastFilter = false;
            }

            if (this.sessionDataConfig["topLevel"].active) {
                this.topLevelIndex = this.firstLevelSort.findIndex(
                    (record) => record.code === this.sessionDataConfig.topLevel.sortingBy
                );
                if (this.sessionDataConfig.topLevel.sortingBy === "dateTime") {
                    this.remainingLevel = 1;
                } else {
                    this.remainingLevel = 2;
                }
            }
            if (this.sessionDataConfig["secondLevel"].active) {
                this.secondLevelIndex = this.secondLevelSort.findIndex(
                    (record) => record.code === this.sessionDataConfig.secondLevel.sortingBy
                );
                if (
                    this.sessionDataConfig["topLevel"].active &&
                    this.sessionDataConfig.topLevel.sortingBy === "dateTime"
                ) {
                    this.remainingLevel = 0;
                } else {
                    this.remainingLevel = 1;
                }
            }
            if (this.sessionDataConfig["thirdLevel"].active) {
                this.thirdLevelIndex = this.thirdLevelSort.findIndex((record) => record.code === this.sessionDataConfig.thirdLevel.sortingBy);
                this.remainingLevel = 0;
            }
            var filter = {};
            filter["limit"] = 10;
            filter["eventId"] = this.sharedService.event.id;
            filter["page"] = 0;
            filter["statusIds"] = ["0", 6, 4];
            this.attendeeSessionService.getSessions(filter).subscribe((resp) => {
                if (resp.body != null && resp.body["sessions"].length > 0) {
                    this.sessionPreviewData = resp["body"];
                    this.defaultData = false;
                    this.sharedService.updateDateTime(this.sessionPreviewData["sessions"], this.filterConfig.selectTimezone);
                } else {
                    this.sessionPreviewData = this.defaultSessionData;
                    this.defaultData = true;
                }
                this.previewOnAdmin.fromAttedee(this.sessionPreviewData, this.sessionDataConfig);
            });
        }

        if(!this.sessionDataConfig.hasOwnProperty('sort')) {
            this.sessionDataConfig.sort = {}
            this.sessionDataConfig.sort.primarySort = '';
            this.sessionDataConfig.sort.primarySortOrder = 'asc';
            this.sessionDataConfig.sort.secondarySort = 'dateTime';
            this.sessionDataConfig.sort.secondarySortOrder = 'asc'
        }

        if(!this.sessionDataConfig.defaultFilters.hasOwnProperty('hidePastSessions')) {
            this.sessionDataConfig.defaultFilters.hidePastSessions = false;
        }
        
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.sessionDataConfig);
        this.sharedService.changedData = this.sessionDataConfig;
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Additional Settings";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-general-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-general-next-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    toggleFilterButton(e): void {
        this.sessionDataConfig.showHidePastFilter = !this.sessionDataConfig.showHidePastFilter;
    }

    goToCreatePage(level) {
        if (level == 2 && this.topLevelIndex > -1) {
            this.sessionDataConfig.secondLevel.active = true;
            this.remainingLevel = level - 1;
        } else if (level == 1 && this.topLevelIndex > -1 && this.sessionDataConfig.topLevel.sortingBy === "dateTime") {
            this.sessionDataConfig.secondLevel.active = true;
            this.remainingLevel = level - 1;
        } else if (level == 1 && this.topLevelIndex > -1 && this.secondLevelIndex > -1) {
            this.sessionDataConfig.thirdLevel.active = true;
            this.remainingLevel = level - 1;
        }
    }
    previewGroup() {
        this.sharedService.loadingList = true;
        if (this.updateStyle && this.sessionDefaultGroupConfig.topLevel == undefined) {
            this.previewOnAdmin.fromAttedee(this.sessionPreviewData, this.sessionDataConfig);
            return;
        }
        if (
            this.sessionDefaultGroupConfig.topLevel.sortingBy != null &&
            this.sessionDefaultGroupConfig.topLevel.sortingBy != undefined
        ) {
            this.sessionDataConfig.topLevel["active"] = true;
        }

        if (
            this.sessionDefaultGroupConfig.secondLevel.sortingBy != null &&
            this.sessionDefaultGroupConfig.secondLevel.sortingBy != undefined
        ) {
            this.sessionDataConfig.secondLevel["active"] = true;
        }

        if (
            this.sessionDefaultGroupConfig.thirdLevel.sortingBy != null &&
            this.sessionDefaultGroupConfig.thirdLevel.sortingBy != undefined
        ) {
            this.sessionDataConfig.thirdLevel["active"] = true;
        }

        this.sessionDataConfig.topLevel["sortingBy"] = this.sessionDefaultGroupConfig.topLevel.sortingBy;
        this.sessionDataConfig.secondLevel["sortingBy"] = this.sessionDefaultGroupConfig.secondLevel.sortingBy;
        this.sessionDataConfig.thirdLevel["sortingBy"] = this.sessionDefaultGroupConfig.thirdLevel.sortingBy;
        if (this.sessionDefaultGroupConfig.dateTimeFormats == undefined) {
            this.sessionDefaultGroupConfig["dateTimeFormats"] = {
                dateFormat: "EEEE, MMMM dd",
                timeFormat: "hh:mm a"
            };
        }

        if (this.sessionDefaultGroupConfig.topLevel.textConfig == undefined || this.updateStyle) {
            if (
                this.sessionDataConfig.topLevel.textConfig != undefined &&
                this.sessionDataConfig.topLevel.textConfig != null
            ) {
                this.sessionDefaultGroupConfig.topLevel["textConfig"] = this.sessionDataConfig.topLevel.textConfig;
            } else {
                this.sessionDefaultGroupConfig.topLevel["textConfig"] = {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                };
            }
        }
        if (this.sessionDefaultGroupConfig.secondLevel.textConfig == undefined || this.updateStyle) {
            if (
                this.sessionDataConfig.secondLevel.textConfig != undefined &&
                this.sessionDataConfig.secondLevel.textConfig != null
            ) {
                this.sessionDefaultGroupConfig.secondLevel[
                    "textConfig"
                ] = this.sessionDataConfig.secondLevel.textConfig;
            } else {
                this.sessionDefaultGroupConfig.secondLevel["textConfig"] = {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                };
            }
        }
        if (this.sessionDefaultGroupConfig.thirdLevel.textConfig == undefined || this.updateStyle) {
            if (
                this.sessionDataConfig.thirdLevel.textConfig != undefined &&
                this.sessionDataConfig.thirdLevel.textConfig != null
            ) {
                this.sessionDefaultGroupConfig.thirdLevel["textConfig"] = this.sessionDataConfig.thirdLevel.textConfig;
            } else {
                this.sessionDefaultGroupConfig.thirdLevel["textConfig"] = {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                };
            }
        }

        this.sessionDataConfig.dateTimeFormats["dateFormat"] = this.sessionDefaultGroupConfig.dateTimeFormats[
            "dateFormat"
        ];
        this.sessionDataConfig.dateTimeFormats["timeFormat"] = this.sessionDefaultGroupConfig.dateTimeFormats[
            "timeFormat"
        ];
        if (this.sessionDefaultGroupConfig.secondLevel.sortingBy == null) {
            this.sessionDataConfig.secondLevel.active = false;
        }
        if (this.sessionDefaultGroupConfig.thirdLevel.sortingBy == null) {
            this.sessionDataConfig.thirdLevel.active = false;
        }
        {
            this.updateStyle = false;
            this.previewOnAdmin.fromAttedee(this.sessionPreviewData, this.sessionDefaultGroupConfig);
        }
    }

    renderView() {
        this.generalList.clear();
        this.generalList.insert(this.sharedService.generalPreviewRef.hostView);
    }

    deleteLevel(level) {
        if (this.sessionDefaultGroupConfig["topLevel"] == undefined) {
            this.sessionDefaultGroupConfig["topLevel"] = this.sessionDataConfig.topLevel;
        }
        if (level == "second") {
            if (this.sessionDataConfig.thirdLevel.active) {
                this._flashMessagesService.show("Can't delete, before Third Level Grouping.", {
                    cssClass: "alert-danger"
                });
            } else {
                this.sessionDataConfig.secondLevel.active = false;
                if (this.sessionDataConfig.topLevel.sortingBy === "dateTime") {
                    this.remainingLevel = 1;
                } else {
                    this.remainingLevel = 2;
                }
                this.sessionDataConfig.secondLevel.sortingBy = null;
                this.sessionDefaultGroupConfig["secondLevel"] = { ["sortingBy"]: null };
                this.sessionDefaultGroupConfig["thirdLevel"] = { ["sortingBy"]: null };
                this.previewGroup();
            }
        } else if (level == "third") {
            this.sessionDataConfig.thirdLevel.active = false;
            this.remainingLevel = 1;
            this.sessionDataConfig.thirdLevel.sortingBy = null;
            this.sessionDefaultGroupConfig["thirdLevel"] = { ["sortingBy"]: null };
            if (this.sessionDefaultGroupConfig["secondLevel"] == undefined) {
                this.sessionDefaultGroupConfig["secondLevel"] = this.sessionDataConfig.secondLevel;
            }
            this.previewGroup();
        }
    }

    valueChangeGroup(e) {
        var group = e.value;
        var ind;
        ind = this.groupTemplate.group.findIndex((record) => record.code === e.value);
        this.sessionDataConfig.group = group;
        this.sessionDefaultGroupConfig = this.groupTemplate.group[ind];
        this.previewGroup();
    }

    valueonSortChange(e) {
        this.sessionDataConfig.sort.primarySort = e.value;
        this.sessionDataConfig.sort.sortOrder = 'asc';
    }

    valueChangeEvent(e, level) {
        if (level == "topLevel") {
            this.secondLevelSort = [];
            this.topLevelIndex = this.firstLevelSort.findIndex((record) => record.code === e.value);
            this.sessionDataConfig.topLevel.sortingBy = e.value;
            this.sortOn.forEach(element => {
                if((this.sessionDataConfig.topLevel.sortingBy == 'date' && element.code == 'dateTime') || (this.sessionDataConfig.topLevel.sortingBy == 'dateTime' && element.code == 'date')) {
                    
                } else if((element.code != this.sessionDataConfig.topLevel.sortingBy)) {
                    this.secondLevelSort.push(element);
                }
            });
            this.sessionDefaultGroupConfig["topLevel"] = { ["sortingBy"]: e.value };
            this.sessionDataConfig.secondLevel.sortingBy = null;
            this.sessionDataConfig.thirdLevel.sortingBy = null;
            this.sessionDefaultGroupConfig["secondLevel"] = { ["sortingBy"]: null };
            this.sessionDefaultGroupConfig["thirdLevel"] = { ["sortingBy"]: null };
            if (this.sessionDataConfig.topLevel.sortingBy === "dateTime") {
                this.remainingLevel = 1;
            } else {
                this.remainingLevel = 2;
            }
            this.previewGroup();
        } else if (level == "secondLevel") {
            this.secondLevelIndex = this.secondLevelSort.findIndex(
                (record) => record.code === e.value
            );
            if (this.sessionDefaultGroupConfig["topLevel"] == undefined) {
                this.sessionDefaultGroupConfig["topLevel"] = this.sessionDataConfig.topLevel;
            }
            this.sessionDataConfig.secondLevel.sortingBy = e.value;
            this.thirdLevelSort = [];
            this.secondLevelSort.forEach(element => {
                if((this.sessionDataConfig.secondLevel.sortingBy == 'date' && element.code == 'dateTime') || (this.sessionDataConfig.secondLevel.sortingBy == 'dateTime' && element.code == 'date')) {
                    
                } else if(element.code != this.sessionDataConfig.topLevel.sortingBy && element.code != this.sessionDataConfig.secondLevel.sortingBy) {
                    this.thirdLevelSort.push(element);
                }
            });
            this.sessionDefaultGroupConfig["secondLevel"] = { ["sortingBy"]: e.value };
            this.sessionDataConfig.thirdLevel.sortingBy = null;
            this.sessionDefaultGroupConfig["thirdLevel"] = { ["sortingBy"]: null };
            if (this.sessionDataConfig.topLevel.sortingBy === "dateTime"  || this.sessionDataConfig.secondLevel.sortingBy === "dateTime") {
                this.remainingLevel = 0;
            } else {
                this.remainingLevel = 1;
            }
            this.previewGroup();
        } else if (level == "thirdLevel") {
            if (this.sessionDefaultGroupConfig["topLevel"] == undefined) {
                this.sessionDefaultGroupConfig["topLevel"] = this.sessionDataConfig.topLevel;
            }
            if (this.sessionDefaultGroupConfig["secondLevel"] == undefined) {
                this.sessionDefaultGroupConfig["secondLevel"] = this.sessionDataConfig.secondLevel;
            }
            this.thirdLevelIndex = this.thirdLevelSort.findIndex((record) => record.code === e.value);
            this.sessionDataConfig.thirdLevel.sortingBy = e.value;
            this.sessionDefaultGroupConfig["thirdLevel"] = { ["sortingBy"]: e.value };
            this.remainingLevel = 0;
            this.previewGroup();
        }
    }

    updateStyle: boolean = false;

    saveSessionConfig(message) {
        if (message.text == "save-general-session" || message.text == "save-general-next-session") {
            if(this.sessionDataConfig.sort.primarySort == this.sessionDataConfig.topLevel.sortingBy || this.sessionDataConfig.sort.primarySort == this.sessionDataConfig.secondLevel.sortingBy || this.sessionDataConfig.sort.primarySort == this.sessionDataConfig.thirdLevel.sortingBy) {
                this._flashMessagesService.show("Sorting value must be different from grouping value", {
                    cssClass: "alert-danger"
                });
                return
            }
            delete this.sessionDataConfig.group;
            this.sessionConfigObj.config = JSON.stringify(this.sessionDataConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.sessionDataConfig);
                this.sharedService.changedData = this.sessionDataConfig;
                this.sharedService.createCss(this.catalogService);
                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.DATA["general"]] = this.sessionConfigObj;
                this._flashMessagesService.show("General Data saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-general-next-session") {
                    this.sharedService.currentLayoutSection = "additional-setting";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/additional-setting");
                }
                this.previewOnAdmin.fromAttedee(this.sessionPreviewData, this.sessionDataConfig);
            });
        } else if (message.text == "apply-grouping-display-config") {
            if (this.sharedService.dataConfig["general"].topLevel.active) {
                if (!this.sharedService.dataConfig["general"].topLevel.textConfig.fontColor) {
                    this.sharedService.dataConfig["general"].topLevel.textConfig.fontColor = "#0d2958";
                }
                if (!this.sharedService.dataConfig["general"].topLevel.textConfig.fontSize) {
                    this.sharedService.dataConfig["general"].topLevel.textConfig.fontSize = 14;
                }
            }

            if (this.sharedService.dataConfig["general"].secondLevel.active) {
                if (!this.sharedService.dataConfig["general"].secondLevel.textConfig.fontColor) {
                    this.sharedService.dataConfig["general"].secondLevel.textConfig.fontColor = "#0d2958";
                }
                if (!this.sharedService.dataConfig["general"].secondLevel.textConfig.fontSize) {
                    this.sharedService.dataConfig["general"].secondLevel.textConfig.fontSize = 14;
                }
            }

            if (this.sharedService.dataConfig["general"].thirdLevel.active) {
                if (!this.sharedService.dataConfig["general"].thirdLevel.textConfig.fontColor) {
                    this.sharedService.dataConfig["general"].thirdLevel.textConfig.fontColor = "#0d2958";
                }
                if (!this.sharedService.dataConfig["general"].thirdLevel.textConfig.fontSize) {
                    this.sharedService.dataConfig["general"].thirdLevel.textConfig.fontSize = 14;
                }
            }
            this.sessionDataConfig = cloneDeep(this.sharedService.dataConfig["general"]);
            this.sharedService.changedData = this.sessionDataConfig;
            this.drawerService.hideDrawer();
            this.updateStyle = true;
            this.previewGroup();
            this.previewCss();
        }
    }

    previewCss() {
        $("#preview").remove();
        $(
            `<style id="preview">${this.sharedService.createCssGeneralData({
                config: JSON.stringify(this.sessionDataConfig)
            })}</style>`
        ).appendTo("body");
    }

    openConfigDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Edit Grouping display",
            navLinks: null,
            saveMessage: "apply-grouping-display-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "grouping-display-config") {
            this.sharedService.dataConfig["general"] = cloneDeep(this.sessionDataConfig);
            url = "config-drawer/grouping/customize-display";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
